import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import { Link } from 'react-router-dom'
import InputText from '../../../../components/commons/form/InputText'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import * as fleetsUtils from '../../../../util/management/fleetsUtils'

class DeliveryDetailsFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      filters: {
        orderBy: '+number'
      },
      dataId: null
    }
  }

  componentDidUpdate () {
    if (this.props.showModal && !this.props.openDeliveryPanel) {
      this.props.fildState('openDeliveryPanel', true)
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.showModal !== prevProps.showModal && this.props.showModal) {
      this.props.actions.fetchDeliveryDetailsFleet(this.props.fleetDeliveryId)
    }

    if (this.props.showModal && this.props.openDeliveryPanel && (!this.props.dossierFleetDetails || this.props.dossierFleetDetails.length === 0) && !prevProps.openDeliveryPanel) {
      this.props.actions.fetchDeliveryDetailsFleet(this.props.fleetDeliveryId)
    }

    if (this.props.showModal && this.props.openDeliveryPanel && (!this.props.dossierFleetDetails || this.props.dossierFleetDetails.length === 0) && this.props.fleet && this.props.fleet.fleetId && !this.props.create) {
      this.props.updateDossiers()
    }
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.deliveryDetails.dossiersFleetDelivery))
    dossiers = dossiers.sort(compareValues(field, order))

    this.props.actions.fetchDeliveryDetailsFleetSuccess({ ...this.props.deliveryDetails, dossiersFleetDelivery: dossiers })
  }

  printDocument () {
    this.props.executeFunctionByName('setOperateActionPrintDeliveryNoteProcess', fleetsUtils, this.props.dossierFleetDetails.filter(dossier => this.props.deliveryDetails.dossiersFleetDelivery.map(d => d.dossierId).includes(dossier.dossierId)), this.props, this.setState.bind(this), true)
  }

  closeModal () {
    this.props.initialize()
    this.props.actions.closeDeliveryDetailsFleetModal()
  }

  render () {
    const {
      t,
      showModal, deliveryDetails
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const tSubKey = 'AUX_MODALS.'

    if (showModal && deliveryDetails) {
      return (
        <Modal id="deliveryDetailsFleetModal" className="_nf" show={showModal} onHide={() => this.closeModal()} backdrop={'static'}>
          <Modal.Header closeButton onHide={() => this.closeModal()}>
            <Modal.Title>{t(`${tKey}${tSubKey}DELIVERY_DETAILS_FLEET_MODAL`) + ' | '}<span>{deliveryDetails.realDeliveryDate + ' - ' + deliveryDetails.realDeliveryTime }</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='infoBlock'>
              <div className='infoRight'>
                <div className='infoItem'><p><span>{t(`${tKey}DOSSIERS`)}:</span>{deliveryDetails.dossierCount}</p></div>
                <div className='infoItem'><p><span>{t(`${tKey}DELIVERY_CITY`)}:</span>{deliveryDetails.deliveryCity}</p></div>
                <div className='infoItem'><p><span>{t(`${tKey}REAL_DELIVERY_ADDRESS`)}:</span>{deliveryDetails.realDeliveryAddress}</p></div>
              </div>
              <div className='infoLeft'>
                <Button
                  className="_Btn accept"
                  id="deliveryDetailsFleetModal_print_button"
                  onClick={() => this.printDocument()}
                  disabled={deliveryDetails?.dossiersFleetDelivery?.filter(dossier => !dossier.isHistorical).length === 0}><i id={'delivery_printDocument'} className="iDocIcon-print-multifunction-printer font-size-large blue"></i>{t(`${tKey}${tSubKey}DELIVERY_FLEET_DOCUMENT`)}</Button>
              </div>
            </div>

            <div className='colWhidht-100 marg-top-20'>
              <Field
                component={InputText}
                colWidht={100}
                id="deleiveryFleetDetailsModal_observations"
                name="deliveryDetails.observations"
                input={{ value: deliveryDetails.observations }}
                componentClass="textarea"
                controlLabel={t(`${tKey}OBSERVATIONS`)}
                placeholder={t(`${tKey}OBSERVATIONS`)}
                disabled={true}
                maxLength={512}
              />
            </div>

            <div id="fleet-dossier-details-table">
              <SimpleTablePage id="fleet-dossier-details-table"
                columns={[
                  <th key={0} data-field="number" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.DOSSIER_NUMBER')}&nbsp;<i className={this.getIconClass('number')}></i>
                  </th>,
                  <th key={1} data-field="vinChassisLicensePlate" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.VEHICLE')}&nbsp;<i className={this.getIconClass('vehicle')}></i>
                  </th>,
                  <th key={2} data-field="brand" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.BRAND')}&nbsp;<i className={this.getIconClass('brand')}></i>
                  </th>,
                  <th key={3} data-field="comercialCode" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.COMMERCIAL_CODE')}&nbsp;<i className={this.getIconClass('comercialCode')}></i>
                  </th>,
                  <th key={4} data-field="model" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.MODEL')}&nbsp;<i className={this.getIconClass('model')}></i>
                  </th>,
                  <th key={5} data-field="color" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.COLOR')}&nbsp;<i className={this.getIconClass('color')}/>
                  </th>
                ]}
                rows={deliveryDetails && deliveryDetails.dossiersFleetDelivery && deliveryDetails.dossiersFleetDelivery.map((row, idx) => (
                  <tr key={idx}>
                    <td>{
                      row.urlToNavigate ? (
                        <Link to={`/dossier${row.urlToNavigate}`}>
                          {row.number}
                        </Link>
                      ) : row.number
                    }</td>
                    <td>{row.vinChassisLicensePlate}</td>
                    <td>{row.brand}</td>
                    <td>{row.comercialCode}</td>
                    <td>{row.model}</td>
                    <td>{row.color}</td>
                  </tr>
                ))}
              ></SimpleTablePage>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className='flexInLine al-C'>
              <Button
                id='btn-close-fleet-delivery-select-charge-modal'
                className="_Btn accept"
                onClick={() => this.closeModal()}>
                {t(`${tKey}CLOSE`)}
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>

      )
    } else {
      return null
    }
  }
}

export default reduxForm({
  form: 'deliveryDetailsFleetModal'
})(DeliveryDetailsFleetModal)
